export enum FrageEinnahme {
  SELBSTAENDIG = 'selbstaendig',

  UNTER_AUFSICHT = 'unter_aufsicht',

  UNSELBSTAENDIG = 'unselbstaendig',
}
